export default __webpack_public_path__ + "static/media/necklace_3.8e22acb5.webp";